import fetch from '@/api/fetch.js'
import { WXMEMBER_API_HOSTNAME } from '@/common/utils/variables.js'

export function initInterest (params, isPolicyCheck) {
  return fetch({
    url: isPolicyCheck ? '/planBook/insurePlan/result/interestInit' : '/planBook/interest/pbInit',
    params
  })
}

export function getInterestDetail (params) {
  return fetch({
    url: '/planBook/interest/detail',
    method: 'post',
    data: params
  })
}

export function saveShareInteraction (params) {
  return fetch({
    url: '/planBook/result/shareSave',
    method: 'post',
    data: params
  })
}

export function getPolicyDetailInfo (params) {
  return fetch({
    url: '/planBook/insurePlan/v2/result/detailInfo',
    method: 'post',
    data: params
  })
}

export function getInterestDetailWithRemark (params, isPolicyCheck) {
  return fetch({
    url: isPolicyCheck ? '/planBook/insurePlan/result/detailWithRemark' : '/planBook/interest/detailWithRemark',
    method: 'post',
    data: params
  })
}

// 查询是否存在任务
export function getDataCollectionMissionExist (params) {
  return fetch({
    url: '/planBook/dataCollection/mission/exist',
    method: 'get',
    params
  })
}

export function getBusinessStrategyByPbUuid(params) {
  return fetch({
      url: '/planBook/businessStrategy/getBusinessStrategyByPbUuid',
      method: 'get',
      params
  })
}
export function calcComparev3Insurance (params) {
  return fetch({
    url: '/planBook/insurance/v3/calculate',
    method: 'post',
    data: params
  })
}

export function getComparev3Insurance (params) {
  return fetch({
    url: '/planBook/insurance/v3/insuranceInit',
    params
  })
}

export function initComparev3InterestData (params) {
  return fetch({
    url: '/planBook/insurance/compare/init',
    params
  })
}
export function saveComparev3Plan (params) {
  return fetch({
    url: '/planBook/insurance/compare/saveComparePlan',
    method: 'post',
    data: params
  })
}
export function getComparev3InterestDetailWithTiers (params) {
  return fetch({
    url: '/planBook/insurance/compare/detailWithTiers',
    method: 'post',
    data: params,
    timeout: 20000
  })
}
export function saveComparev3 (params) {
  return fetch({
    url: '/planBook/insurance/compare/saveCompareResult',
    method: 'post',
    data: params
  })
}

//是否允许产品对比跳转利益对比
export function getIsJumpToCompare3Exist (insuranceId) {
  return fetch({
    url: `planBook/insurance/compare/exist?insuranceId=${insuranceId}`,
    method: 'get',
  })
}

//查询会员状态
export function getUserPlanBookMemberInfo () {
  return fetch({
    baseURL: WXMEMBER_API_HOSTNAME,
    url: `superMember/getUserPlanBookMemberInfo`,
    method: 'get',
  })
}
